import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { AzureSqlTableDataset } from './azure-sql-table.dataset';
import { format } from 'app/shared/utils/string.util';
import { AzureSqlMILinkedService, type IModel, Metamodel } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.azureSqlMI.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureSQLManagedInstance_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureSQLManagedInstance_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureSqlMILinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureSqlMITableDataset extends AzureSqlTableDataset {
    public static readonly MODEL: IModel;
}
